module.exports = __webpack_public_path__ + "static/media/IT1.9a1aa329.png";